export const WIDE_SCREEN_BREAK_POINT = 1200;

export const WEB_HEADER_ROUTE_NAMES = {
  AUTHORIZED: 'Authorized',
  DASHBOARD: 'Dashboard',
  PLANBOARD: 'Planboard',
  WALLBOARD: 'Wallboard',
  SEARCH: 'Search',
  SETTINGS: 'Settings',
} as const;

export const DASHBOARD_INITIAL_SCREEN = 'DashboardOverview';

export const WEB_HEADER_ROUTE_PATHS: Record<string, string> = {
  [WEB_HEADER_ROUTE_NAMES.AUTHORIZED]: '/machines',
  [WEB_HEADER_ROUTE_NAMES.WALLBOARD]: '/wallboard',
  [WEB_HEADER_ROUTE_NAMES.SEARCH]: '/search',
  [WEB_HEADER_ROUTE_NAMES.SETTINGS]: '/settings',
  [WEB_HEADER_ROUTE_NAMES.PLANBOARD]: '/planboard',
  [WEB_HEADER_ROUTE_NAMES.DASHBOARD]: '/dashboard',
};

export const WEB_HEADER_LAYOUT = {
  horizontalPadding: 18,
  leftLogoContainerWidth: 135,
  sLogoWidth: 18,
  sLogoHeight: 24,
  tabHorizontalMargin: 6,
  phoneTabWidth: 120,
  rightClusterWidth: 202,
  userImageSize: 28,
  fullScreenActiveZIndex: 100000,
  bigIndexResetTimeoutMs: 2000,
} as const;

export const WEB_HEADER_ICON_SIZES = {
  zoom: 16,
  cog: 18,
  theme: { width: 23, height: 22 },
  infoFilled: 20,
  plusSmall: 18,
  tileSize: { width: 20, height: 13 },
} as const;

export const WEB_HEADER_COLORS = {
  menuApp: 'Background/Light/menuApp',
  menuWeb: 'Background / Light / menuWeb',
  hairlinePrimary: 'Hairline/Light/Primary',
  selectedPrimary: 'Selected/Light/Primary',
  unselectedLabel: 'Label/Light/Unselected Web',
} as const;

export const CHANGE_TILE_SIZE_POPUP_WIDTH = 480;

export const WEB_HEADER_STYLES_CONFIG = {
  container: {
    gapWideScreen: 30,
    gapNarrowScreen: 23,
  },
  item: {
    width: 28,
    height: 28,
    borderRadius: 28,
    backgroundColorHoveredNotPressed: 'Background/Light/hover menuWeb',
    backgroundColor: 'transparent',
  },
};
